import { render, staticRenderFns } from "./FaqCategories.vue?vue&type=template&id=5e2a28c1&scoped=true&"
import script from "./FaqCategories.vue?vue&type=script&lang=js&"
export * from "./FaqCategories.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategories.vue?vue&type=style&index=0&id=5e2a28c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a28c1",
  null
  
)

export default component.exports